import { render } from "./Index.vue?vue&type=template&id=bddbc01a"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/lf.m2geo.ie/releases/20261103161156/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Profile/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bddbc01a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bddbc01a', __exports__)) {
    console.log('reload')
    api.reload('bddbc01a', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=bddbc01a", () => {
    console.log('re-render')
    api.rerender('bddbc01a', render)
  })

}


export default __exports__